import processUnclosedTags from './processUnclosedTags';

const getPureText = (text: string) => {
  const balancedText = processUnclosedTags(text);

  if (typeof window === 'undefined') {
    return balancedText.replace(/<[^>]*>/g, '');
  }

  const temp = document.createElement('div');
  temp.innerHTML = balancedText;

  return temp.textContent || '';
};

export default getPureText;
